import { apiGet } from "../client";
import type { IExamAssignment } from "./types";
import { useQuery } from "@tanstack/react-query";

export async function getExamAssignment(id: string) {
  const response = await apiGet<IExamAssignment>(`/exam_assignments/${id}`);
  return response.data;
}

export function useQueryGetExamAssignment(id: string) {
  return useQuery({
    queryKey: ["examAssignment", id],
    queryFn: () => getExamAssignment(id),
    enabled: !!id,
  });
}
